import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';

import {SharedModule, ComponentModule} from 'synto-common';
import {SyntoCoreModule} from 'synto-common/synto-core';

import {SyntoDocumentListComponent} from './synto-document-list.component';
import {DocumentApprovalDialogComponent} from './document-approval-dialog/document-approval-dialog.component';
import {DocumentReplaceDialogComponent} from './document-replace-dialog/document-replace-dialog.component';
import {DocumentArchiveDialogComponent} from './document-archive-dialog/document-archive-dialog.component';
import {DocumentRenameDialogComponent} from './document-rename-dialog/document-rename-dialog.component';

@NgModule({
  declarations: [
    SyntoDocumentListComponent,
    DocumentApprovalDialogComponent,
    DocumentReplaceDialogComponent,
    DocumentArchiveDialogComponent,
    DocumentRenameDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    SharedModule,
    ComponentModule,
    SyntoCoreModule
  ],
  exports: [SyntoDocumentListComponent]
})
export class SyntoDocumentListModule {
}
